import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import AffiliateLayout from '../../components/AffiliateLayout/AffiliateLayout';
import api from '../../services/api';
import {
  PageTitle, PageSub, Head, StatGrid, Tile, TileNum, TileLabel, Card, TableWrap,
  Table, Pill, Spinner, Empty, NameCell, colors,
} from '../../components/AffiliateUI/AffiliateUI';

// Demo-walkthrough lead list, ported from the standalone affiliates.zona.miami
// portal — everyone who's opened the affiliate demo, verified or not.

const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';

const AffiliateDemos = () => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState('');

  useEffect(() => {
    const t = setTimeout(() => {
      api.get('/affiliate-admin/demo-leads', { params: q.trim() ? { search: q.trim() } : {} })
        .then(({ data }) => setRows(data.data || []))
        .catch(() => { toast.error('Failed to load demo leads'); setRows([]); });
    }, q ? 300 : 0);
    return () => clearTimeout(t);
  }, [q]);

  const verified = (rows || []).filter((r) => r.verified).length;
  const repeat = (rows || []).filter((r) => r.visit_count > 1).length;

  return (
    <AffiliateLayout>
      {!rows ? <Spinner /> : (
            <>
              <Head>
                <div>
                  <PageTitle>Demo views</PageTitle>
                  <PageSub>Everyone who's opened the affiliate demo walkthrough.</PageSub>
                </div>
              </Head>

              <StatGrid>
                <Tile><TileNum>{rows.length}</TileNum><TileLabel>Leads</TileLabel></Tile>
                <Tile><TileNum>{verified}</TileNum><TileLabel>Phone verified</TileLabel></Tile>
                <Tile><TileNum>{repeat}</TileNum><TileLabel>Repeat visitors</TileLabel></Tile>
                <Tile><TileNum>{rows.reduce((s, r) => s + (r.visit_count || 1), 0)}</TileNum><TileLabel>Total visits</TileLabel></Tile>
              </StatGrid>

              <Search>
                <Icon icon="solar:magnifer-outline" width={16} />
                <input placeholder="Search name, email, phone, IG, code…" value={q} onChange={(e) => setQ(e.target.value)} />
              </Search>

              <Card>
                <TableWrap>
                  <Table>
                    <thead>
                      <tr>
                        <th>Name</th><th>Email</th><th>Phone</th><th>IG</th>
                        <th className="num">Visits</th><th>Verified</th><th>First seen</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((r) => (
                        <tr key={r._id}>
                          <td>
                            <NameCell>
                              <span className="n">{r.name || 'Unnamed'}</span>
                              {r.promo_code && <span className="code">&nbsp;{r.promo_code}</span>}
                            </NameCell>
                          </td>
                          <td>{r.email || '—'}</td>
                          <td>{r.phone || '—'}</td>
                          <td>{r.ig ? `@${r.ig.replace(/^@/, '')}` : '—'}</td>
                          <td className="num strong">{r.visit_count || 1}</td>
                          <td>{r.verified ? <Pill tone="green">verified</Pill> : <Pill tone="muted">no</Pill>}</td>
                          <td>{fmtDate(r.created_at)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </TableWrap>
                {rows.length === 0 && <Empty>No demo leads {q ? `match "${q}".` : 'yet.'}</Empty>}
              </Card>
            </>
      )}
    </AffiliateLayout>
  );
};

export default AffiliateDemos;

const Search = styled.label`
  display: flex; align-items: center; gap: 8px; margin-bottom: 14px;
  height: 40px; padding: 0 14px; background: ${colors.bgInput};
  border: 1px solid ${colors.border}; border-radius: 10px; color: ${colors.textMuted};
  input { flex: 1; background: none; border: none; outline: none; color: #fff; font-size: 14px; }
  input::placeholder { color: ${colors.textFaint}; }
`;
